import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
        <FAQSection />
        <AboutSection />
        <CarouselSection />
        <AppSection />
        <TopicsSection />
        <CommentsSection />
        <MediaSection />
        <UpdatesSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}